import React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';


/*******components*********/
import Home from "./containers/home";
import Agreement from "./containers/agreement";
import Coupon from "./containers/coupon";
import BindPhone from "./containers/bindphone";
import MyCource from "./containers/myCource";
import CourseVedio from "./containers/coursevedio";
import VerificationComponent from "./containers/bindphone/verification";
import OrderPage from "./containers/order";
function App() {
    return (
        <HashRouter>
            <Switch>
                <Route exact path="/" render={() => <Redirect to='/home'></Redirect>}></Route>
                <Route path="/home" exact component={ Home } />
                <Route path="/play" component={ CourseVedio }/>
                <Route path="/agree" component={ Agreement } />
                <Route path="/coupon" component={ Coupon }/>
                <Route path="/cource" component={ MyCource }/>
                <Route path="/bind" component={ BindPhone }/>
                <Route path="/verification" component={ VerificationComponent }/>
                <Route path="/order" component={ OrderPage } />
            </Switch>
        </HashRouter>
    );
}

export default App;
